import {
  // eslint-disable-next-line no-restricted-imports
  Button as ButtonBase,
  type ButtonProps as ButtonPropsBase,
} from "@clipboard-health/ui-components";
import { type LocationState } from "history";

import { ButtonInternalLink } from "./ButtonInternalLink";

export interface ButtonProps extends Omit<ButtonPropsBase, "LinkComponent"> {
  locationState?: LocationState;
}

export function Button(props: ButtonProps) {
  return <ButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
